/***
 **Module Name: BlockBuyer
 **File Name :  BlockBuyer.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains BlockBuyer details.
 ***/
 import React, { useState, useEffect ,useContext} from "react";
 import Footer from "../../components/dashboard/footer";
 import Header from "../../components/dashboard/header";
 import Sidebar from "../../components/dashboard/sidebar";
 import { useNavigate, Link } from "react-router-dom";
 import SweetAlert from "react-bootstrap-sweetalert";
 import axios from "axios";
 import Loader from "../../components/loader";
 import moment from "moment";
 import SessionPopup from "../SessionPopup"
 import ReactQuill from 'react-quill';
 import 'react-quill/dist/quill.snow.css';
 import { contentContext } from "../../context/contentContext";
 let { appname, lambda } = window.app;
 const useQuillMixin = (defaultValue = '') => {
    const [value, setValue] = useState(defaultValue);
     const [plainvalue, setPlainValue] = useState(defaultValue);
  
    useEffect(() => {
      // Perform any additional setup or side effects here
      console.log('Quill setup completed');
    }, []);
  
   const handleChange = (content, delta, source, editor) => {
  const text = editor.getText(); // plain text without HTML


    setValue(content); // update state normally
   setPlainValue(text)
  
};
  
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'list': 'bullet' }],
            ['bold', 'italic', 'underline', 'strike', 'link'],
        ],
    }
  
    const formats = [
      // Add your formats here if needed
      // Example: 'bold', 'italic', 'underline', 'strike'
    ];
  
    const quillElement = (
        <ReactQuill
                  theme="snow"
                  // modules={{ toolbar: true }}
                  formats={['header', 'list', 'bold', 'italic', 'underline', 'strike', 'link']}
                  value={value}
                  onChange={handleChange}
                  modules={modules}
              //  formats={formats}
              />
    );
  
    return { quillElement, value, setValue,plainvalue,setPlainValue };
  };
 
 const WelcomeMessage = () => {
     const navigate = useNavigate();
     const { quillElement, value, setValue,plainvalue,setPlainValue } = useQuillMixin();
     const [menuCode, setMenuCode] = useState(0);
     const [success, setSuccess] = useState(false);
      
     const [msgError, setMsgError] = useState("");
     const [showSessionPopupup, setShowSessionPopupup] = useState(false);

     const {route, setRoute,setCurrentPage,setRowsPerPage,usePrevious, setActiveMenuId,GetTimeActivity} = useContext(contentContext);

     const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute != undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
         }
     }, [prevRoute]);
     const handleBack = () => {
        GetTimeActivity()   
         navigate("/frontendsettings")
     }
    useEffect(() => {
     
             if (window.site === undefined) {
                 setTimeout(() => {
                    
                     if (window.site && window.site.duration ) {
                         setValue(window.site.duration)
                     }
                 }, 1000);
             }
              
             if (window.site && window.site.common && window.site.common.imagesCDN) {
                 setValue(window.site.duration)
             }
     
         }, [window.site]);
  const validate = () => {
        let formIsValid = true;
       let errorMsg = "";
       
 if (plainvalue.length > 500) {
              
                 errorMsg = "Must be no more than 500 characters.";
                 setTimeout(function () { setMsgError("") }, 3000);
                formIsValid = false;
            }
        


      

        console.log("error", errorMsg);
        setMsgError(errorMsg);

        return formIsValid;
    };
     useEffect(() => {
        setRoute("frontend")
        setActiveMenuId(200007)
        //  handleMenu();
         userActivity();
     }, []);
     const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };
  

   const previousId = localStorage.getItem("previousid");
const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
   
 
      const handleUpdate=async()=>{
    const isValid= validate()
     try {
         if (!isValid) {
   
   
      return; // stop submission
    }
    const payload = {
    duration:value
    };

    const previousId = localStorage.getItem("previousid");
    const urlLink =
      lambda +
      "/config?appname=" +
      appname +
      (previousId ? "&previousid=" + previousId : "");

    const response = await axios.post(urlLink, payload);

    if (response?.data?.result === "Invalid token or Expired") {
      setShowSessionPopupup(true);
      
    } else if (response?.data?.result === "Updated Successfully") {
     
      setSuccess(true)
      if (typeof window.websiteDefaults === "function") {
  window.websiteDefaults();
}

    }
  } catch (error) {
    console.error("Error while sending user activity:", error);
   
  }
  }
     function onConfirm() {
        GetTimeActivity()   
        setSuccess(false);
      };
      
      
      
 
      console.log("value",value)
     return (
         <>
         {showSessionPopupup && <SessionPopup />}
             <div id="layout-wrapper">
                 <Header />
                 <Sidebar />
                 <div className="main-content create-user edit-content add-client lps">
 
                     <div className="page-content ">
                         <div className="container-fluid">
                             <div className="row mb-4 breadcrumb">
                                 <div className="col-lg-9">
                                     <div className="d-flex align-items-center">
                                         <div>
                                             <h4 className="mb-2 card-title">Welcome Message </h4>
                                             <p className="menu-path">Front End Settings / <b>Welcome Message </b></p>
                                         </div>
                                         {/* <button className="btn btn-primary ml-25 border_button" type="button" onClick={handleUpdate}><span className="material-symbols-outlined"> save </span>Update</button> */}
 
 
                                     </div>
                                 </div>
                                 <div className="col-lg-3 align-right">
                                     <button onClick={handleBack} className="btn btn-primary" type="button" >BACK</button>
                                 </div>
                             </div>
                             <div className="create-user-block mb_20">
                             {value.length > 0 ? 
                                            <> 
                                 <div className="form-block">
                                     <div>
                                     {quillElement}
                                      {msgError && <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{msgError}</span>}
                                         {/* <ReactQuill theme="snow" value={value} onChange={setValue} /> */}
                                         <button style={{marginTop:"20px"}} className="btn btn-primary ml-25 border_button" type="button" onClick={handleUpdate}><span className="material-symbols-outlined"> save </span>Update</button>
                                     </div>
 
                                 </div>
                                 </>
                                        : 
                                      
                                        <div className="form-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row"><Loader />
                                                    </div>
                                                </div>
                                                </div>  </div>
                                       
                                                }
                             </div>
 
 
 
                         </div>
                     </div>
 
 
                     <Footer />
                     <SweetAlert show={success}
                                                custom
                                                confirmBtnText="ok"
                                                confirmBtnBsStyle="primary"
                                                title={"Updated successfully"}
                                                onConfirm={e => onConfirm()}
                                            >
                                            </SweetAlert>
                                              
                 </div>
             </div>
         </>
     );
 };
 
 export default WelcomeMessage;
 